import { useEffect } from "react";

export const useAutoResizeTextarea = (textareaRef, value) => {
  useEffect(() => {
    if (!textareaRef.current) return;

    textareaRef.current.style.height = "auto";
    textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
  }, [textareaRef, value]);
};

export default useAutoResizeTextarea;
